'use strict';
var i18n = require('../i18n'),
  $d = require('../dependency');

module.exports = {
    get i18n() {
        return i18n[$d.lang];
    }
};
// module.exports = i18n.enUS;
